import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import HotDramas from "@/pages/home/components/HotDramas";
import NewsPreview from "@/pages/home/components/NewsPreview";
import AboutStrip from "@/pages/home/components/AboutStrip";

export default function Home() {
  usePageMeta(
    "仙剑奇侠传影视站-经典仙侠剧全集与剧情介绍",
    "仙剑奇侠传网站提供丰富的仙侠电视剧资源，包括剧情介绍、角色分析和最新资讯，满足粉丝对经典仙侠剧的多方位需求。",
    "仙剑奇侠传,仙侠剧,仙剑奇侠传剧情,仙剑奇侠传电视剧,古装剧,仙侠影视,经典电视剧"
  );

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryShortcuts />
      <HotDramas />
      <NewsPreview />
      <AboutStrip />
    </div>
  );
}